import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal appointment-modal" }
const _hoisted_2 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "appointmentCreateModel",
  tabindex: "-1",
  "aria-labelledby": "feedbackModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "shadowed-card bg-white mb-2 p-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_7 = { class: "title" }
const _hoisted_8 = {
  class: "modal-body",
  id: "appointmentModelScroll"
}
const _hoisted_9 = { class: "form-wrap" }
const _hoisted_10 = { action: "" }
const _hoisted_11 = { class: "bg-light p-3 mb-3 rounded" }
const _hoisted_12 = { class: "form-group mb-0" }
const _hoisted_13 = { for: "" }
const _hoisted_14 = { class: "inline-items" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = {
  for: "",
  class: "to-upper"
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = {
  for: "",
  class: "to-upper"
}
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = {
  for: "",
  class: "to-upper"
}
const _hoisted_24 = {
  key: 0,
  class: "bg-light p-3 mb-3 rounded"
}
const _hoisted_25 = { class: "form-group mb-0" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { for: "" }
const _hoisted_28 = /*#__PURE__*/_createVNode("input", {
  type: "text",
  class: "form-control",
  placeholder: "www.locationurl.com"
}, null, -1)
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { for: "" }
const _hoisted_31 = /*#__PURE__*/_createVNode("input", {
  type: "text",
  class: "form-control",
  placeholder: "www.locationurl.com"
}, null, -1)
const _hoisted_32 = {
  key: 1,
  class: "bg-light p-3 mb-3 rounded"
}
const _hoisted_33 = { class: "form-group mb-0" }
const _hoisted_34 = {
  for: "location",
  class: "to-upper"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { id: "locationField" }, [
  /*#__PURE__*/_createVNode("input", {
    id: "autocomplete",
    placeholder: "Enter your address",
    onFocus: "geolocate()",
    type: "search",
    class: "form-control",
    autocomplete: "off"
  })
], -1)
const _hoisted_36 = { class: "bg-light p-3 mb-3 rounded" }
const _hoisted_37 = { class: "form-group mb-0" }
const _hoisted_38 = { for: "" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { for: "" }
const _hoisted_41 = { class: "modal-footer" }
const _hoisted_42 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeAppointmentModal && _ctx.closeAppointmentModal(...args))),
                class: "close",
                "aria-label": "Close"
              }, [
                _hoisted_6
              ]),
              _createVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t('appointment_detail')), 1)
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.errorList,
                hasError: _ctx.state.isErrorStatus
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_9, [
                _createVNode("form", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('meeting_via')), 1),
                      _createVNode("div", _hoisted_14, [
                        _createVNode("ul", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.meetingVia, (meeting) => {
                            return (_openBlock(), _createBlock("li", { key: meeting }, [
                              _createVNode("label", null, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  name: "optionsRadios",
                                  id: meeting.name,
                                  value: meeting.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.meetingType = $event)),
                                  onChange: ($event: any) => (_ctx.checkLogin(meeting.value))
                                }, null, 40, ["id", "value", "onChange"]), [
                                  [_vModelRadio, _ctx.state.meetingType]
                                ]),
                                _createTextVNode(" " + _toDisplayString(meeting.name), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('add_new_appointment_title')), 1),
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      placeholder: "Project discuss",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.title = $event)),
                      readonly: ""
                    }, null, 512), [
                      [_vModelText, _ctx.state.title]
                    ])
                  ]),
                  _createVNode(_component_v_date_picker, {
                    modelValue: _ctx.state.data.range,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.range = $event)),
                    mode: "dateTime",
                    masks: _ctx.masks,
                    "min-date": new Date(),
                    popover: { placement: _ctx.$screens({ default: 'left' }) },
                    "is-range": ""
                  }, {
                    default: _withCtx(({ inputValue, inputEvents }) => [
                      _createVNode("div", _hoisted_17, [
                        _createVNode("div", _hoisted_18, [
                          _createVNode("div", _hoisted_19, [
                            _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('meeting_start_date_time')), 1),
                            _createVNode("input", _mergeProps({
                              class: "form-control",
                              value: inputValue,
                              readonly: ""
                            }, _toHandlers(inputEvents)), null, 16, ["value"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_21, [
                          _createVNode("div", _hoisted_22, [
                            _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('meeting_end_date_time')), 1),
                            _createVNode("input", {
                              class: "form-control",
                              value: _ctx.state.data.range.end,
                              readonly: ""
                            }, null, 8, ["value"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "masks", "min-date", "popover"]),
                  (_ctx.state.meetingType == 'skype')
                    ? (_openBlock(), _createBlock("div", _hoisted_24, [
                        _createVNode("div", _hoisted_25, [
                          (_ctx.state.meetingType == 'skype')
                            ? (_openBlock(), _createBlock("div", _hoisted_26, [
                                _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('meeting_url_id')), 1),
                                _hoisted_28
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.meetingType == 'zoom')
                            ? (_openBlock(), _createBlock("div", _hoisted_29, [
                                _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('meeting_code')), 1),
                                _hoisted_31
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.meetingType == 'physical')
                    ? (_openBlock(), _createBlock("div", _hoisted_32, [
                        _createVNode("div", _hoisted_33, [
                          _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('location')), 1),
                          _hoisted_35
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_36, [
                    _createVNode("div", _hoisted_37, [
                      _createVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('invite_user')), 1),
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.state.data.tags.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.tags.value = $event)),
                        mode: "tags",
                        searchable: true,
                        options: _ctx.state.data.tags.options,
                        onTag: _ctx.addTag,
                        createTag: true
                      }, null, 8, ["modelValue", "options", "onTag"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_39, [
                    _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('appointment_note')), 1),
                    _withDirectives(_createVNode("textarea", {
                      class: "form-control",
                      placeholder: "note if any",
                      rows: "5",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.note = $event)),
                      readonly: ""
                    }, null, 512), [
                      [_vModelText, _ctx.state.note]
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_41, [
              _createVNode("div", _hoisted_42, [
                _createVNode("button", {
                  class: "btn secondary-btn",
                  type: "submit",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeAppointmentModal && _ctx.closeAppointmentModal(...args)))
                }, _toDisplayString(_ctx.$t('cancel')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.SuccessFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}